import { useMemo } from 'react';
import moment, { Moment } from 'moment';
import { FetchSessionsByDateTimeDocument } from '@modernhealth/circles-graphql/v2';

import { useQueryWithMultipleCalls } from './useQueryWithMultipleCalls';

type Month = {
    monthStart: string;
    monthEnd: string;
    upcomingYear: boolean;
};
const getUpcomingMonthsTimes = (count: number, stringMoment: string) => {
    const result: Month[] = [];

    let monthStart: Moment | string = moment().startOf('month');
    const currentMoment = moment(stringMoment);
    for (let i = 1; i <= count; i++) {
        // New year is coming up next if the year of new month (monthStart) is not the same as the year of current moment,
        // and the new month is January
        const isNewYearComingUp =
            monthStart.year() !== currentMoment.year() && monthStart.month() === 0;

        monthStart = i === 1 ? currentMoment : monthStart;
        const monthEnd = moment(monthStart).add(1, 'month').startOf('month');

        result.push({
            monthStart: monthStart.toISOString(),
            monthEnd: monthEnd.toISOString(),
            upcomingYear: isNewYearComingUp,
        });

        monthStart = moment(monthEnd);
    }

    return result;
};

export const useGetMonthsData = (numberOfMonths: number, currentMoment: string) => {
    const calls = useMemo(() => {
        const monthsTimes = getUpcomingMonthsTimes(numberOfMonths, currentMoment);
        return monthsTimes.map(month => {
            return {
                key: month,
                variables: {
                    startDateTime: month.monthStart,
                    endDateTime: month.monthEnd,
                    first: 100,
                    last: null,
                    after: null,
                    before: null,
                },
            };
        });
    }, [numberOfMonths, currentMoment]);

    return useQueryWithMultipleCalls(FetchSessionsByDateTimeDocument, calls);
};
